import { styled } from '@linaria/react';
import { colors, fonts, layout, space } from '../../theme/tokens';

export const Header = styled.div`
  text-align: center;
  padding-bottom: ${space[7]};
  margin-bottom: ${space[7]};
  border-bottom: 1px solid ${colors.borderGrey};
`;

export const ConfirmationMeta = styled.p`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${colors.fontSecondary};
  margin: ${space[2]} 0 0;
  line-height: 1.5;

  strong {
    color: ${colors.fontPrimary};
    font-weight: ${fonts.weight.semiBold};
  }
`;

export const VoucherList = styled.ul`
  list-style: none;
  margin: ${space[2]} 0 0;
  padding: 0;
`;

export const VoucherItem = styled.li`
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  color: ${colors.fontSecondary};
  line-height: 1.5;
`;

export const Columns = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${space[7]};

  @media (min-width: ${layout.desktopBreakpoint}) {
    grid-template-columns: 1fr 1fr;
    gap: 0;
    align-items: stretch;
  }
`;

export const BookingColumn = styled.div`
  @media (min-width: ${layout.desktopBreakpoint}) {
    padding-right: ${space[7]};
  }
`;

export const SectionTitle = styled.h2`
  font-family: ${fonts.body};
  font-size: ${fonts.size.lg};
  font-weight: ${fonts.weight.semiBold};
  color: ${colors.fontPrimary};
  margin: 0 0 ${space[3]};
  max-width: ${layout.modalWidth};
`;

export const BookingList = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ManageBooking = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[3]};
  width: 100%;

  @media (min-width: ${layout.desktopBreakpoint}) {
    border-left: 1px solid ${colors.borderGrey};
    padding-left: ${space[7]};
  }
`;

export const ManageBookingDescription = styled.p`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${colors.fontSecondary};
  margin: 0;
  line-height: 1.5;
  max-width: ${layout.modalWidth};
`;

export const CreateAccountForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${space[3]};
  max-width: ${layout.modalWidth};
`;

export const UpsellSection = styled.div`
  margin-top: ${space[9]};
  text-align: center;
`;

export const UpsellGridWrapper = styled.div`
  text-align: left;
  margin-top: ${space[6]};
`;
